<div class="high-contrast">
    <a id="id-high-contrast-a" href=""
       class="d-flex"
       (click)="switchAccessibility(); (false)">
        <img [src]="highContrastImage" alt="high contrast mode"/>
    </a>
</div>
